import { render, staticRenderFns } from "./reportSetting.vue?vue&type=template&id=5732b4a3&scoped=true&"
import script from "./reportSetting.vue?vue&type=script&lang=ts&"
export * from "./reportSetting.vue?vue&type=script&lang=ts&"
import style0 from "./reportSetting.vue?vue&type=style&index=0&id=5732b4a3&prod&lang=scss&scoped=true&"
import style1 from "./reportSetting.vue?vue&type=style&index=1&id=5732b4a3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5732b4a3",
  null
  
)

export default component.exports